import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export interface ConfirmationModalProps {
  show: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Header closeButton onClick={onCancel}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="light" className="new-modal-btn-cancel" onClick={onCancel}>
          {cancelText ? t(cancelText) : t("cancel")}
        </Button>
        <Button variant="" className="new-modal-btn-confirm" onClick={onConfirm}>
          {confirmText ? t(confirmText) : t("delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
